import {ProductOption} from "./ProductCard"
import {NO_EAP} from "./constants"

export const FLEXI_POINTS_OPTIONS: ProductOption[] = [
  {
    name: "0",
    value: "Flexi points x0",
    body: "admin.billing.renewals.newPlanCards.flexiPoints.x0.body",
    bold: ["", "", ""],
    checked: true
  },
  {
    name: "10",
    value: "Flexi points x10",
    body: "admin.billing.renewals.newPlanCards.flexiPoints.x10.body",
    bold: [
      "admin.billing.renewals.newPlanCards.flexiPoints.x10.bold1",
      "admin.billing.renewals.newPlanCards.flexiPoints.x10.bold2",
      "admin.billing.renewals.newPlanCards.flexiPoints.x10.bold3"
    ],
    checked: false
  },
  {
    name: "25",
    value: "Flexi points x25",
    body: "admin.billing.renewals.newPlanCards.flexiPoints.x25.body",
    bold: [
      "admin.billing.renewals.newPlanCards.flexiPoints.x25.bold1",
      "admin.billing.renewals.newPlanCards.flexiPoints.x25.bold2",
      "admin.billing.renewals.newPlanCards.flexiPoints.x25.bold3"
    ],
    checked: false
  },
  {
    name: "30",
    value: "Flexi points x30",
    body: "admin.billing.renewals.newPlanCards.flexiPoints.x30.body",
    bold: ["admin.billing.renewals.newPlanCards.flexiPoints.x30.bold1", "admin.billing.renewals.newPlanCards.flexiPoints.x30.bold2"],
    checked: false
  },
  {
    name: "40",
    value: "Flexi points x40",
    body: "admin.billing.renewals.newPlanCards.flexiPoints.x40.body",
    bold: ["admin.billing.renewals.newPlanCards.flexiPoints.x40.bold1", "admin.billing.renewals.newPlanCards.flexiPoints.x40.bold2"],
    checked: false
  },
  {
    name: "50",
    value: "Flexi points x50",
    body: "admin.billing.renewals.newPlanCards.flexiPoints.x50.body",
    bold: [
      "admin.billing.renewals.newPlanCards.flexiPoints.x50.bold1",
      "admin.billing.renewals.newPlanCards.flexiPoints.x50.bold2",
      "admin.billing.renewals.newPlanCards.flexiPoints.x50.bold3"
    ],
    checked: false
  },
  {
    name: "60",
    value: "Flexi points x60",
    body: "admin.billing.renewals.newPlanCards.flexiPoints.x60.body",
    bold: ["admin.billing.renewals.newPlanCards.flexiPoints.x60.bold1", "admin.billing.renewals.newPlanCards.flexiPoints.x60.bold2"],
    checked: false
  },
  {
    name: "90",
    value: "Flexi points x90",
    body: "admin.billing.renewals.newPlanCards.flexiPoints.x90.body",
    bold: ["admin.billing.renewals.newPlanCards.flexiPoints.x90.bold1", "admin.billing.renewals.newPlanCards.flexiPoints.x90.bold2"],
    checked: false
  },
  {
    name: "120",
    value: "Flexi points x120",
    body: "admin.billing.renewals.newPlanCards.flexiPoints.x120.body",
    bold: [
      "admin.billing.renewals.newPlanCards.flexiPoints.x120.bold1",
      "admin.billing.renewals.newPlanCards.flexiPoints.x120.bold2",
      "admin.billing.renewals.newPlanCards.flexiPoints.x120.bold3"
    ],
    checked: false
  }
]

export const EAP_OPTIONS: ProductOption[] = [
  {
    name: NO_EAP,
    value: NO_EAP,
    body: NO_EAP,
    bold: [""],
    checked: true
  },
  {
    name: "Basic",
    value: "Basic EAP",
    body: "admin.billing.renewals.newPlanCards.eap.basic.body",
    bold: ["admin.billing.renewals.newPlanCards.eap.basic.bold1"],
    checked: false
  },
  {
    name: "Enhanced",
    value: "Enhanced EAP",
    body: "admin.billing.renewals.newPlanCards.eap.enhanced.body",
    bold: [
      "admin.billing.renewals.newPlanCards.eap.enhanced.bold1",
      "admin.billing.renewals.newPlanCards.eap.enhanced.bold2",
      "admin.billing.renewals.newPlanCards.eap.enhanced.bold3"
    ],
    checked: false
  }
]
